import React, { useCallback } from "react"
import cn from "classnames"
import css from "./Beats.module.scss"
import Preloader from "features/Preloader/Preloader"
import useAudioController from "shared/hooks/useAudioController"
import useDelayedLoading from "shared/hooks/useDelayedLoading"

export default function BeatCard({ beat = null, playingBeat = "", setPlayingBeat = null, stop = null }) {
  const { isLoading, click } = useAudioController({ beat, playingBeat, setPlayingBeat, stop })
  const showLoader = useDelayedLoading(isLoading)
  const isStopCard = typeof stop === "function"

  const currentSongIsPlaying = Boolean(playingBeat) && !isStopCard && playingBeat === beat?.id

  const handleClick = useCallback(() => {
    if (isStopCard) {
      stop()
    } else {
      click()
    }
  }, [isStopCard, stop, click])

  return (
    <button
      type="button"
      className={cn(
        css.beatCard,
        currentSongIsPlaying && css.beatCardActive,
        beat?.isBonus && css.beatCardBonus,
        isStopCard && css.beatCardStop
      )}
      onClick={handleClick}
    >
      {showLoader && <Preloader />}
      <span className={css.beatCardLetter}>{isStopCard ? "STOP" : beat?.label}</span>
    </button>
  )
}
